import * as Yup from 'yup';

export const serviceTypeFormSchema = Yup.object().shape({
    serviceTypeName: Yup.string().required('Service type name is required'),
});
